"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _nuiIntl = require("@concur/nui-intl");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _reactModal = _interopRequireDefault(require("react-modal"));

var _listingModule = require("./listingModule");

var _utils = require("../utils");

var _trackClick = require("../HOCs/trackClick");

var AnalyticsModule = _interopRequireWildcard(require("../analytics/modules/AnalyticsModule"));

var _analytics = require("../constants/analytics");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var style = {
  overlay: {
    zIndex: '100',
    position: 'fixed',
    backgroundColor: 'rgba(0, 0, 0, 0.5)'
  },
  content: {
    position: 'initial',
    width: '600px',
    maxHeight: '80%',
    margin: '75px auto'
  }
};

var UnenrollModal = function UnenrollModal(_ref) {
  var isUnenrollModalOpen = _ref.isUnenrollModalOpen,
      toggle = _ref.toggle,
      modalNames = _ref.modalNames,
      unenroll = _ref.unenroll,
      userId = _ref.userId,
      listingId = _ref.listingId,
      companyUUID = _ref.companyUUID,
      v1ListingId = _ref.v1ListingId,
      listingData = _ref.listingData,
      trackButtonClick = _ref.trackButtonClick;
  var listingName;

  if (listingData[listingId] !== undefined && listingData[listingId].data !== undefined) {
    listingName = listingData[listingId].data.core ? listingData[listingId].data.core.listingName : listingData[v1ListingId].data.core.listingName;
  } else {
    listingName = listingData[v1ListingId].data.core ? listingData[v1ListingId].data.core.listingName : listingData[listingId].data.core.listingName;
  }

  var toggleThisModal = function toggleThisModal() {
    trackButtonClick({
      elementPath: [[_analytics.listingConst, listingName].join(' '), _analytics.modal.unenroll, _analytics.button.x],
      dimensions: {
        listingId: listingId,
        listingName: listingName,
        companyUUID: companyUUID
      }
    });
    toggle(modalNames.unenroll);
  };

  if (!(0, _utils.canUseDOM)()) {
    return _react.default.createElement("span", null, "Javascript is Required to Unenroll");
  }

  var handleUnenroll = function handleUnenroll() {
    toggleThisModal();
    return unenroll(listingId, v1ListingId);
  };

  var trackClicked = function trackClicked(element, additional) {
    return _react.default.createElement(_trackClick.Tracked, {
      event: "CLICK",
      additional: Object.assign(additional, {
        context: 'LISTING_DETAILS',
        type: 'BUTTON',
        v2_listing_id: listingId,
        app_name: listingName,
        domain: window.location.hostname
      })
    }, element);
  };

  _reactModal.default.setAppElement('#root');

  return _react.default.createElement("div", null, _react.default.createElement(_reactModal.default, {
    style: style,
    isOpen: isUnenrollModalOpen,
    onRequestClose: toggleThisModal,
    contentLabel: "Unenroll from listing modal"
  }, _react.default.createElement("div", {
    className: "row inside-modal"
  }, _react.default.createElement("div", {
    className: "col-xs-11"
  }, _react.default.createElement("h3", null, _react.default.createElement(_nuiIntl.FormattedMessage, {
    id: "Confirmation"
  }))), _react.default.createElement("div", {
    className: "col-xs-1"
  }, _react.default.createElement("span", {
    className: "close-tandc-modal pull-right",
    onClick: toggleThisModal
  }, "\xD7"))), _react.default.createElement("hr", null), _react.default.createElement("div", {
    className: "row"
  }, _react.default.createElement("div", {
    className: "col-xs-1"
  }, _react.default.createElement("span", {
    className: "icon-messaging-warning icon-size-lg"
  })), _react.default.createElement("div", {
    className: "col-xs-11",
    style: {
      paddingTop: '17px'
    }
  }, _react.default.createElement(_nuiIntl.FormattedMessage, {
    id: "UnenrollAreYouSure"
  }))), _react.default.createElement("hr", null), _react.default.createElement("div", {
    className: "row"
  }, _react.default.createElement("div", {
    className: "col-xs-12"
  }, trackClicked(_react.default.createElement("button", {
    style: {
      minWidth: '110px',
      marginLeft: '10px'
    },
    className: "btn btn-lg btn-default pull-right",
    onClick: handleUnenroll
  }, _react.default.createElement(_nuiIntl.FormattedMessage, {
    id: "Yes"
  })), {
    value: 'UNENROLL_MODAL_YES'
  }), trackClicked(_react.default.createElement("button", {
    style: {
      minWidth: '110px'
    },
    className: "btn btn-lg btn-default cnqr-muted pull-right",
    onClick: toggleThisModal
  }, _react.default.createElement(_nuiIntl.FormattedMessage, {
    id: "No"
  })), {
    value: 'UNENROLL_MODAL_NO'
  })))));
};

var mapStateToUnenrollProps = function mapStateToUnenrollProps(state) {
  return {
    isUnenrollModalOpen: state.listing.isUnenrollModalOpen,
    modalNames: state.listing.modalNames,
    userId: state.userPrefs.userId,
    options: state.listing.modalOptions,
    listingData: state.listing,
    companyUUID: state.userPrefs.companyUUID
  };
};

UnenrollModal.propTypes = {
  isUnenrollModalOpen: _propTypes.default.bool.isRequired,
  modalNames: _propTypes.default.object.isRequired,
  unenroll: _propTypes.default.func.isRequired,
  toggle: _propTypes.default.func.isRequired,
  userId: _propTypes.default.string,
  listingId: _propTypes.default.string,
  v1ListingId: _propTypes.default.string,
  listingData: _propTypes.default.object,
  companyUUID: _propTypes.default.string,
  trackButtonClick: _propTypes.default.func
};

var _default = (0, _reactRedux.connect)(mapStateToUnenrollProps, {
  toggle: _listingModule.toggleModal,
  unenroll: _listingModule.disconnectListing,
  trackButtonClick: AnalyticsModule.buttonClickDispatch
})(UnenrollModal);

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./lib/listing/UnenrollModal.js
// module id = 270
// module chunks = 0